<template>
  <setting-applicant-auto-reply
    title="話を聞きたい応募（カジュアル面談）受付メッセージ自動送信設定"
    :default-mail-subject="defaultMailSubject"
    :default-mail-text="defaultMailText"
    :setting-api-url="settingApiUrl"
  >
    <template #scoutMailNote>
      <div data-test="scout-mail-note">
        例）すぐに面談の日程を案内したい/スカウト応募者には特別な対応をしたい
        など
      </div>
    </template>
    <template #beforeSendingNote>
      <div
        class="pega-annotation-container margin-top-1"
        data-test="before-sending-note"
      >
        <div>・話を聞きたい応募（カジュアル面談）とは、選考前面談への応募のことを意味します。</div>
        <div>&emsp;通常の選考希望とは異なるのでご注意ください</div>
        <div class="margin-top-1">
          ※話を聞きたい応募の詳細はこちら
        </div>
        <div>{{ helpUserGuideUrl }}</div>
        <div class="margin-top-1">
          ・面談の候補日を連絡する目安を明記していますか？
        </div>
        <div>※再度連絡するまでの期間を明記することで応募者に安心感を与えることができます。</div>
        <div class="margin-top-1">
          例）
        </div>
        <div>「応募内容の確認には1週間～10日程度のお時間をいただいております。」</div>
        <div>「面談を実施する場合は、候補日を1週間～2週間でご連絡させていただきます。」</div>
      </div>
    </template>
  </setting-applicant-auto-reply>
</template>

<script>
import SettingApplicantAutoReply from '@/components/organisms/SettingApplicantAutoReply'

const DEFAULT_MAIL_TEXT = `■USER_NAME■ 様

この度は、弊社求人の面談にご応募いただきまして誠にありがとうございます。

これから、お送りいただいた応募内容を拝見させていただきます。

面談を実施させていただく場合のみ、
2～3営業日程度で改めてご連絡させていただきますので
何卒よろしくお願いいたします。

※本メールは「話を聞きたい」より応募いただいた方への自動返信メールです。予めご了承下さい。
`

export default {
  components: {
    SettingApplicantAutoReply
  },
  data () {
    return {
      defaultMailSubject: '「話を聞きたい」のご応募ありがとうございます',
      defaultMailText: DEFAULT_MAIL_TEXT,
      settingApiUrl: '/settings/casual_interview_message_auto_reply'
    }
  },
  computed: {
    helpUserGuideUrl: () => `${process.env.API_ENDPOINT}/help/guide/index_276.html`
  }
}
</script>
